module.exports = __webpack_public_path__ + "static/media/arrow_down.19f009ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/arrow_down.svg
// module id = 547
// module chunks = 2